import { useClassFactory } from "@pasta/box-v2";
import { ref } from "vue";
import { BeforeLeaveNavigationException } from "../errors/navigation.exception";
import { useSentry } from "@pasta/front-sentry-v2";

export class NavigationChecker {
  commentText = ref<string>("");

  check() {
    if (this.commentText.value) {
      const answer = window.confirm(
        "Vous n'avez pas envoyé votre commentaire, êtes vous sûr(e) de vouloir quitter la page ?"
      );
      if (!answer) {
        useSentry().addBreadcrumb({
          message: "canceled navigation because unsubmitted comment",
        });
        throw new BeforeLeaveNavigationException("Canceled nav");
      }
      this.commentText.value = "";
    }
  }
}

export const [navigationCheckerToken, useNavigationChecker] = useClassFactory(NavigationChecker);
